export default __webpack_public_path__ + "assets/images/baccarat-13dd3b00959ac896234512dd7f8f39af.svg";